
export class AppNavigationModel{
    enableMenu: boolean = false;
    enableBackButton: boolean = false;
    remainHeaderPadding: boolean = false;
}